import axios, { isAxiosError } from 'axios';

import { ApiResponse } from '../model';

/** Машинный код 403 от LegalAgreementRequiredPermission (строковый override в envelope). */
export const LEGAL_AGREEMENT_REQUIRED = 'legal_agreement_required';

export interface LegalPrivacyDocument {
  doc_type: string;
  version: number;
  file_url: string;
}

export interface LegalAgreementFlags {
  legal_agreement_accepted: boolean;
  legal_agreement_version: number | null;
}

/**
 * Достаёт `error_code` из axios error envelope.
 * По умолчанию бэкенд кладёт HTTP status (number); view может передать строковый машинный код.
 */
export function getApiErrorCode(error: unknown): string | number | undefined {
  if (!isAxiosError(error)) {
    return undefined;
  }

  const data = error.response?.data;
  if (data == null || typeof data !== 'object') {
    return undefined;
  }

  const code = (data as { error_code?: unknown }).error_code;
  if (typeof code === 'string' || typeof code === 'number') {
    return code;
  }

  return undefined;
}

export function isLegalAgreementRequiredError(error: unknown): boolean {
  return getApiErrorCode(error) === LEGAL_AGREEMENT_REQUIRED;
}

export class LegalApi {
  static readonly KEY = 'legal';

  static async getPrivacy(): Promise<LegalPrivacyDocument> {
    const { data } = await axios.get<ApiResponse<LegalPrivacyDocument>>(
      '/api/v1/public/legal/privacy',
    );

    return data.data;
  }

  static async agree(version?: number): Promise<LegalAgreementFlags> {
    const { data } = await axios.post<ApiResponse<LegalAgreementFlags>>(
      '/api/v1/client/legal/agree',
      version === undefined ? {} : { version },
    );

    return data.data;
  }
}
